import { CALL_API } from 'redux-api-middleware';
import * as fromAuth from '../../modules/auth';
import * as fromRootReducer from '../../modules/root-reducer';

const isAuthenticatedAPIAction = (action) => {
  const callAPI = action[CALL_API];
  return callAPI && callAPI.options && callAPI.options.addAuth;
};

export const middleware = ({
  refresh,
  authError,
  getIsAuthenticated,
  getRefreshTokenExpiration,
  getIdTokenExpiration,
}) => store => {
  let isAwaitingRefresh = false;
  let refreshPromise = Promise.resolve();
  return next => async action => {

  // If this isn't an authenticated API call, we skip this middleware
    if (!isAuthenticatedAPIAction(action)) {
      return next(action);
    }

    const state = store.getState();

    // If we don't have an auth token, we just automatically fail this action
    if (!getIsAuthenticated(state)) {
      const failureType = action[CALL_API].types[2];
      const err = new Error('Not logged in');
      err.ignore = true;
      return next({
        type: failureType.type || failureType,
        error: true,
        payload: err,
      });
    }

    if (isAwaitingRefresh) {
      await refreshPromise;
      return next(action);
    }

    // Make sure the refresh token is still valid
    const refTokenTimeToExpire = new Date(getRefreshTokenExpiration(state)).getTime() - Date.now();
    if (refTokenTimeToExpire <= 0) return next(authError()); // nothing to do here. Force a logout.

    const expiresAt = getIdTokenExpiration(state);

    if( ! expiresAt ){
      return next(action);
    }

    const timeToExpire =  expiresAt - Date.now();

    // If token is expired or will expire within 30 seconds, refresh then make the request
    if (timeToExpire < 30e3) {
      isAwaitingRefresh = true;
      refreshPromise = next(refresh());
      await refreshPromise;
      isAwaitingRefresh = false;
      return next(action);
    }

    // If the token expires in less than 30 minutes but is still valid, refresh in parallel
    if (timeToExpire < 30 * 60e3) {
      next(refresh());
      return next(action);
    }
    // Otherwise, just make the request
    return next(action);
  };
};

export default middleware({
  refresh: fromAuth.refresh,
  authError: fromAuth.authenticationError,
  getIsAuthenticated: fromRootReducer.getIsAuthenticated,
  getIdTokenExpiration: fromRootReducer.getIdTokenExpiration,
  getRefreshTokenExpiration: fromRootReducer.getRefreshTokenExpiration,
  getRefreshToken: fromRootReducer.getRefreshToken,
});
